import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  body: css`
    padding-inline-start: 0 !important; // Переопределил свойство у <Text> компонента
  `,
}
